import { render } from "./ActivateForm.vue?vue&type=template&id=07d1793e&ts=true"
import script from "./ActivateForm.ts?vue&type=script&lang=ts&external"
export * from "./ActivateForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__